import React from "react";
import Button from "material-ui/Button";
import { withStyles } from "material-ui/styles";
import { connect } from 'react-redux';
import { compose } from 'recompose';
import styles from "./styles";
import Icon from "material-ui/Icon";
import TextField from "material-ui/TextField";
import Title from "../ui/title";
import Content from "../ui/content";
import Context from "./context/";
import SearchBar from "../common/search";
import Toolbar from "./toolbar/";
import EmailReport from "./sendreport";

import Select from "material-ui/Select";
import { MenuItem } from "material-ui/Menu";
import Input from "material-ui/Input";
import Tooltip from "material-ui/Tooltip";

import { dateTimeFormatter, getISODateString } from "../../common/utils";
import Table from "../table";

import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";
import DatePicker from "material-ui-pickers/DatePicker";
import moment from "moment";
import MomentUtils from "material-ui-pickers/utils/moment-utils";
import ConfirmDialog from "../common/dialog/confirm";
import { APP_CONFIG } from "../../config";
import RefreshSignalR from "../signalr/refresh-signalr";
moment.suppressDeprecationWarnings = true;

const StatusSelect = props => {
  return (
    <Select
      value={props.value ? props.value : ""}
      onChange={props.onChange}
      input={
        <Input
          name="status"
          id="status"
          value={props.value ? props.value : "all"}
        />
      }
      fullWidth
    >
      <MenuItem value="all">{props.translate("general_showall")}</MenuItem>
      <MenuItem value="in_progress">
        {props.translate("report_status_in_progress")}
      </MenuItem>
      <MenuItem value="completed">
        {props.translate("report_status_completed")}
      </MenuItem>
    </Select>
  );
};

const TypeSelect = props => {
  return (
    <Select
      value={props.value ? props.value : ""}
      onChange={props.onChange}
      input={
        <Input
          name="type"
          id="type"
          value={props.value ? props.value : "all"}
        />
      }
      fullWidth
    >
      <MenuItem value="all">{props.translate("general_showall")}</MenuItem>
      <MenuItem value="singleline">
        {props.translate("report_type_singleline")}
      </MenuItem>
      <MenuItem value="brief">{props.translate("report_type_brief")}</MenuItem>
      <MenuItem value="standard">
        {props.translate("report_type_standard")}
      </MenuItem>
    </Select>
  );
};

class Reports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedReports: [],
      selectAll: false,
      contextMenu: false,
      columns: null,
      selected: {},
      sendemailmodal: false,
      filterable: false,
      selectedDateTime: null,
      showConfirmDelete: false,
      showConfirmEmail: false,
      signalRConnectionActive: false
    };
    this.toggle = this.toggle.bind(this);
    this.toggleColumns = this.toggleColumns.bind(this);
    this.selectedRows = this.selectedRows.bind(this);
    this.sendEmailReport = this.sendEmailReport.bind(this);
  }

  componentWillMount() {
    const { reports, pager, translate, reportDownload, classes } = this.props;
    const { defaultColumns } = pager;
    const { filterable, selectedDateTime } = this.state;
    let columns = [];
    this.props.saveSelectedRow(null);
    
    reports.columns.forEach(column => {
      if (column.field === "filesize") {
        columns.push({
          id: column.field,
          Header: translate(column.field),
          accessor: d => d[column.field],
          show: defaultColumns.includes(column.field),
          Cell: o => {
            return <span>{parseInt(o.row.filesize / 1024, 10)}KB</span>;
          },
          filterable: column.cansearch && filterable,
          cansearch: column.cansearch,
          sortable: column.cansort,
          display: column.display
        });
      } else if (column.field === "type") {
        columns.push({
          id: column.field,
          Header: translate(column.field),
          accessor: d => d[column.field],
          show: true,
          Cell: o => {
            return <span>{translate(`report_type_${o.row.type}`)}</span>;
          },
          filterable: column.cansearch && filterable,
          cansearch: column.cansearch,
          sortable: column.cansort,
          Filter: ({ filter, onChange }) => (
            <TypeSelect
              onChange={event =>
                onChange(event.target.value === "all" ? "" : event.target.value)
              }
              value={filter ? filter.value : "all"}
              translate={translate}
            />
          ),
          display: column.display
        });
      } else if (column.field === "status") {
        columns.push({
          id: column.field,
          Header: translate(column.field),
          accessor: d => d[column.field],
          show: true,
          Cell: o => {
            return <span>{translate(`report_status_${o.row.status}`)}</span>;
          },
          filterable: column.cansearch && filterable,
          cansearch: column.cansearch,
          sortable: column.cansort,
          Filter: ({ filter, onChange }) => (
            <StatusSelect
              onChange={event =>
                onChange(event.target.value === "all" ? "" : event.target.value)
              }
              value={filter ? filter.value : "all"}
              translate={translate}
            />
          ),
          display: column.display
        });
        columns.push({
          id: "download",
          display: false,
          show: true,
          filterable: false,
          Header: "",
          width: 30,
          accessor: d => d[column.field],
          Cell: o => {
            return o.original.status === "completed" ? 
            (
              <Button
                mini
                className={classes.downloadButton}
                onClick={() => reportDownload(o.row)}
              >
                {o.original.multiplePdf == true ? (
                  <img
                    alt=""
                    className={[classes.zip_icon]}
                    src={"/images/zip_icon.png"}
                  />
                ) : (
                  <Icon>cloud_download</Icon>
                )}
              </Button>
            ) : 
            o.original.status === 'in_progress' ? 
            (
              <Tooltip
                    title={translate("uploaded_tests_status") + ' ' + o.original.totaltest}
                    disableTriggerFocus={true}
                  >
                    <span>{o.original.progress}</span>
              </Tooltip>
            ) : 
            (
              <span />
            );
          },
          Filter: () => null
        });
      } else if (column.field === "createdat") {
        columns.push({
          id: column.field,
          Header: translate(column.field),
          accessor: d => d[column.field],
          show: defaultColumns.includes(column.field),
          Cell: o => {
            return dateTimeFormatter(o.row.createdat);
          },
          filterable: column.cansearch && filterable,
          cansearch: column.cansearch,
          sortable: true,
          width: 220,
          Filter: ({ filter, onChange }) => {
            return (
              <React.Fragment>
                <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
                  <div className="picker">
                    <DatePicker
                      value={selectedDateTime}
                      onChange={event => {
                        this.setState(
                          {
                            selectedDateTime: event ? event._d : null
                          },
                          () => {
                            if (!event) {
                              onChange("");
                              return "";
                            }
                            let date = getISODateString(event._d);
                            onChange(date);
                            return date;
                          }
                        );
                      }}
                      disableFuture
                      clearable
                      ampm={false}
                      format="DD/MM/YYYY"
                    />
                  </div>
                </MuiPickersUtilsProvider>
              </React.Fragment>
            );
          },
          display: true
        });
      } else if (column.field === "timetaken") {
        columns.push({
          id: column.field,
          Header: translate('result_testtime'),
          accessor: d => d[column.field],
          show: true,
          Cell: o => {
            return <span>{o.row.timetaken}</span>;
          },
          filterable: false,
          cansearch: false,
          sortable: false,
          display: column.display
        });
      } else {
        if (column.field === "name") {
          columns.push({
            id: column.field,
            Header: translate(column.field),
            accessor: d => d[column.field],
            show: defaultColumns.includes(column.field),
            filterable: column.cansearch && filterable,
            cansearch: column.cansearch,
            sortable: false,
            display: column.display
          });
        } else {
          columns.push({
            id: column.field,
            Header: translate(column.field),
            accessor: d => d[column.field],
            show: defaultColumns.includes(column.field),
            filterable: column.cansearch && filterable,
            cansearch: column.cansearch,
            sortable: column.cansort,
            display: column.display
          });
        }
      }
    });

    this.setState({
      columns: columns
    });
  }

  /*componentWillUnmount() {
    clearInterval(this.interval);
  }*/

  checkReportStatus = () => {
    var reportIds = this.getInProgressReportIds();

    console.log("check report status " + reportIds);

    if (reportIds && reportIds.length > 0) {
      fetch(APP_CONFIG.baseURL + "Report/Status?reportIds=" + reportIds)
      .then(data => data.json())
      .then((result) => {
        if (result) {
          this.refreshList();
        }
      },
      (error) => {
        console.log(error);
      })
      .finally(() => {
        setTimeout(this.checkReportStatus(reportIds), 10000);
      });
    }
  }

  getInProgressReportIds = () => {
    if (this.props.reports && this.props.reports.data) {
      var reportIds = this.props.reports.data.filter(x => x.status === 'in_progress').map(x => x.id);

      if (reportIds && reportIds.length > 0) {
        var reportIdsForQueryString = '';

        reportIds.forEach(x => {
          reportIdsForQueryString = reportIdsForQueryString + '~' + x;
        });

        return reportIdsForQueryString;
      }
    }

    return null;
  }

  sendemailreport(reportIds) {
    const { selectedReports } = this.state;
    let failedReports =
      selectedReports && selectedReports.filter(x => x.status == "failed");
    if (failedReports.length > 0) {
      this.setState({
        showConfirmEmail: true
      });
    } else {
      this.setState({
        sendemailmodal: true
      });
    }
  }
  email = () => {
    this.setState({
      showConfirmEmail: false,
      sendemailmodal: true
    });
  };

  hideConfirmEmail = () => {
    this.setState({
      showConfirmEmail: false
    });
  };

  closeModal = reset => {
    reset && this.props.reset();
    this.setState({
      sendemailmodal: false
    });
  };

  showConfirmDel = reportIds => {
    const { reports } = this.props;
    //let data = reports.data ? reports.data.find(x => x.id === reportId) : null;
    this.setState({
      reportIds: reportIds,
      showConfirmDelete: true
    });
  };

  hideConfirmDel = () => {
    this.setState({
      showConfirmDelete: false
    });
  };

  del = () => {
    let { selectedReports } = this.state;
    this.props
      .deleteReport(this.state.reportIds, this.props.pager)
      .then(response => {
        this.setState({
          selected: {},
          selectedReports: []
        });
      });
    this.hideConfirmDel();
  };

  sendEmailReport = email => {
    const { selected } = this.state;
    let { selectedReports } = this.state;
    let reportid = Object.keys(selected).filter(x => selected[x] === true);

    this.props
      .sendEmail({
        email: email.recipients,
        reportid: reportid
      })
      .then(response => {
        this.setState({
          selected: {},
          selectedReports: []
        });
      });
    this.setState({
      sendemailmodal: false
    });
  };

  refreshList = () => {
    this.props.refresh();
  };

  render() {
    const {
      translate,
      reports,
      search,
      fetch,
      pager,
      saveSelectedRow,
      previousRow,
      impersonating,
      softwareUpdate
    } = this.props;

    const {
      selected,
      filterable,
      selectedReports,
      selectAll,
      reportCount
    } = this.state;

    let selectedRecords = Object.keys(selected).filter(x => selected[x]);

    let margintop = "150px";

    if (impersonating && softwareUpdate) {
      margintop = "275px";
    } else if (impersonating || softwareUpdate) {
      margintop = "215px";
    }

    const _selected = { ...selected };
    let $context = (
      <Context
        toggleColumns={this.toggleColumns}
        data={reports.data}
        translate={translate}
        columns={this.state.columns}
      />
    );
    const { sendemailmodal } = this.state;

    let $sendemailmodal = sendemailmodal ? (
      <EmailReport
        close={this.closeModal}
        translate={translate}
        submit={this.sendEmailReport}
      />
    ) : null;

    let confirmText = translate("report_delete_confirm_text2", {
      name:
        selectedReports && selectedReports.length ? selectedReports.length : ""
    });

    let confirmEmailText = translate("report_email_confirm_text");

    return (
      <div style={{marginTop: margintop}}>
        <div>
          <Title
            title={translate("general_reports")}
            toolbar={
              <Toolbar
                translate={translate}
                toggle={() => this.toggle()}
                sendemailreport={() => this.sendemailreport(selectedRecords)}
                selectedRecords={selectedRecords}
                showEmail={selectedRecords.length >= 1}
                toggleFilters={this.toggleFilters}
                remove={() => this.showConfirmDel(selectedRecords)}
                refresh={this.refreshList}
                signalRUpdate={this.state.signalRConnectionActive}
              />
            }
          />
          <Content
            ctx={$context}
            open={this.state.contextMenu}
            toggle={() => this.toggle()}
            translate={translate}
          >
            {filterable ? (
              <SearchBar search={search} pager={pager} translate={translate} />
            ) : null}
            <Table
              translate={translate}
              filterable
              pages={reports.pagecount}
              manual={pager.manual}
              minRows={0}
              pager={pager}
              defaultPageSize={pager.pagesize}
              data={reports.data}
              columns={this.state.columns}
              fetch={fetch}
              allowSelect
              selectedRows={this.selectedRows}
              selectAll={selectAll}
              selected={_selected}
              style={{
                border: "none",
              }}
              noDataText="no_reports_data"
              selectedTests={selectedReports}
              saveSelectedRow={saveSelectedRow}
              isShiftSelectPage={true}
              previousRow={previousRow}
              isReportPage={true}
            />
            {$sendemailmodal}
            <ConfirmDialog
              open={this.state.showConfirmDelete}
              title={translate("report_delete_confirm_title")}
              contentText={confirmText}
              contentSecondaryText={translate("general_confirmation_help_2")}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.del}
              onCancel={this.hideConfirmDel}
            />
            <ConfirmDialog
              open={this.state.showConfirmEmail}
              title={translate("report_email_confirm_title")}
              contentText={confirmEmailText}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.email}
              onCancel={this.hideConfirmEmail}
            />
          </Content>
        </div>
        <RefreshSignalR
          onTableStateChanged={() => {
            this.refreshList();
          }}
          onSignalRConnected={() => {
            this.setSignalR(true); 
          }}
          onSignalRDisconnected={() => {
            this.setSignalR(false);
          }}
          table={"reports"}
          refreshRate={5000}
        />
      </div>
    );
  }

  selectedRows = (rows, prevReports) => {
    let { selectedReports } = this.state;
    const { reports, app, pager } = this.props;
    //const { reports } = app;
    if (prevReports.length > 0) {
      selectedReports = prevReports;
    } else {
      selectedReports = [];
    }

    Object.keys(rows).map(key => {
      if (rows[key]) {
        selectedReports.push(reports.data.find(x => x.id == parseInt(key, 10)));
      } else {
        selectedReports.forEach((element, idx) => {
          if (element && element.id.toString() === key) {
            selectedReports.splice(idx, 1);
          }
        });
      }
      return key;
    });

    selectedReports = selectedReports.filter(i => i !== undefined);
    selectedReports = this.getUnique(selectedReports, "id");
    this.sortSelection(pager.order, selectedReports);

    this.setState({
      selectedReports,
      selectAll:
        reports.data.filter(obj => obj.status != "in_progress").length ===
        reports.data.filter(e => rows[e.id]).length,
      selected: rows
    });
  };

  getUnique = (arr, comp) => {
    const unique = arr
      .map(e => e[comp])
      .map((e, i, final) => final.indexOf(e) === i && i)
      .filter(e => arr[e])
      .map(e => arr[e]);

    return unique;
  };

  sortSelection = (sort, selectedReports) => {
    if (Object.keys(sort).length) {
      selectedReports = selectedReports.sort((x, y) => {
        return x[sort.field] !== y[sort.field]
          ? x[sort.field] < y[sort.field]
            ? -1
            : 1
          : 0;
      });
      if (sort.sorttype === "desc") {
        selectedReports = selectedReports.reverse();
      }
    } else {
      selectedReports = selectedReports.sort((x, y) => {
        return x.name !== y.name ? (x.name < y.name ? -1 : 1) : 0;
      });
    }
    if (this.props.setSelectedTests) {
      this.props.setSelectedTests(
        selectedReports.length ? selectedReports : null
      );
    }
  };

  toggle() {
    this.setState({
      contextMenu: !this.state.contextMenu
    });
  }

  setSignalR(connected) {
    this.setState({
      signalRConnectionActive: connected
    });
  }

  toggleColumns(column) {
    let columns = [...this.state.columns];

    columns.forEach(c => {
      if (c.id === column.id) {
        c.show = column.show;
      }
    });
    this.setState({
      columns: columns
    });
  }

  toggleFilters = () => {
    let columns = [...this.state.columns];
    let { filterable } = this.state;
    columns.forEach(c => {
      c.filterable = c.cansearch && !filterable;
    });
    this.setState({
      columns: columns,
      filterable: !filterable
    });
  };

  setColumns(props) {
    const { filterable, selectedDateTime, columns } = this.state;

    let col = columns.find(col => col.id === "createdat");
    if (col) {
      col.Filter = ({ filter, onChange }) => {
        return (
          <React.Fragment>
            <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
              <div className="picker">
                <DatePicker
                  value={selectedDateTime}
                  onChange={event => {
                    this.setState(
                      {
                        selectedDateTime: event ? event._d : null
                      },
                      () => {
                        if (!event) {
                          onChange("");
                          return "";
                        }
                        let date = getISODateString(event._d);
                        onChange(date);
                        return date;
                      }
                    );
                  }}
                  disableFuture
                  clearable
                  ampm={false}
                  format="DD/MM/YYYY"
                />
              </div>
            </MuiPickersUtilsProvider>
          </React.Fragment>
        );
      };
    }

    this.setState({
      columns: columns
    });
  }

  componentWillReceiveProps(nextProps) {
    const props = { ...nextProps };
    this.setColumns(props);
  }
}

const mapStateToProps = (state) => ({
  impersonating: state.userReducer.impersonating,
  softwareUpdate: state.userReducer.softwareUpdate,
  ...state,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(Reports);



// WEBPACK FOOTER //
// ./src/components/reports/index.js